const CryptoJS = require("crypto-js");
const SHA256 = require("crypto-js/sha256");

const useCryptography = () => {
  const encrypt = (value) => {
    if (!value instanceof String) {
      return value;
    }

    if (!value || value.length === 0) {
      return value;
    }

    let hashedValue;

    try {
      hashedValue = CryptoJS.AES.encrypt(
        value,
        process.env.REACT_APP_LOCAL_KEY
      ).toString();

      return hashedValue;
    } catch (err) {
      return value;
    }
  };

  const decrypt = (hashedValue) => {
    let bytes;
    try {
      if (!hashedValue instanceof String) {
        return hashedValue;
      }

      if (hashedValue.length === 0) {
        return hashedValue;
      }

      bytes = CryptoJS.AES.decrypt(
        hashedValue,
        process.env.REACT_APP_LOCAL_KEY
      );

      let value = bytes.toString(CryptoJS.enc.Utf8);

      return value;
    } catch (err) {
      return hashedValue;
    }
  };

  // Generate daily passcode from base secret + date
  const generateDailyPasscode = (date = new Date(), base = "Marketsupport") => {
    // Format date as YYYY-MM-DD (UTC)
    const formatDate = (date = new Date()) => date.toISOString().slice(0, 10);

    const input = base + formatDate(date);
    const hash = SHA256(input).toString();
    const numeric = parseInt(hash.slice(0, 8), 16);
    return (numeric % 1000000).toString().padStart(6, "0");
  };

  return {
    encrypt,
    decrypt,
    generateDailyPasscode,
  };
};

export default useCryptography;
